import { TFunction } from 'i18next';
import { NavItemTypeEnum } from '@lib/components/Menu/Menu';
import { Ordering } from '../enums';

export default function getSortingNavItems({
  t,
  orderingDirection,
  onSortingChange,
}: {
  t: TFunction<'translation', undefined>;
  orderingDirection: string;
  onSortingChange: (v: Ordering) => void;
}) {
  return [
    {
      id: 'default',
      title: t('default'),
      onClick: () => onSortingChange(Ordering.Default),
      type: NavItemTypeEnum.PrimaryText,
      itemClassName:
        orderingDirection === Ordering.Default ? 'active' : undefined,
    },
    {
      id: 'a-z',
      title: t('a-z'),
      onClick: () => onSortingChange(Ordering.AtoZ),
      type: NavItemTypeEnum.PrimaryText,
      itemClassName: orderingDirection === Ordering.AtoZ ? 'active' : undefined,
    },
    {
      id: 'z-a',
      title: t('z-a'),
      onClick: () => onSortingChange(Ordering.ZtoA),
      type: NavItemTypeEnum.PrimaryText,
      itemClassName: orderingDirection === Ordering.ZtoA ? 'active' : undefined,
    },
  ];
}
